import React from 'react';
import { getCardId, CapabilityCardItem } from './cardHelpers';

// Shared by LgSlides/XlSlides/SmSlides - the three breakpoints render an
// identical single-row-per-group layout, only the caller's className/prop
// order historically differed (no visual difference).
const cardSlides = (slides, isPortalLivePreview = false, enableB2CRadius = false) => slides?.map((group, groupKey) => (
  <div className="sui-flex sui-w-full sui-gap-y-4 sui-flex-col" key={groupKey}>
    {group?.map((card, cardKey) => {
      const cardId = getCardId(card, cardKey);

      return (
        <div className="capability_card" key={cardKey + cardId}>
          <CapabilityCardItem
            card={card}
            cardId={cardId}
            cardKey={cardKey}
            isPortalLivePreview={isPortalLivePreview}
            enableB2CRadius={enableB2CRadius}
          />
        </div>
      );
    })}
  </div>
));

export default cardSlides;
